import { DAY_MS } from './constants';

/** Days since the Unix epoch (UTC). Firestore rules compute the same value from request.time. */
export function utcDayNumber(ms: number): number {
  return Math.floor(ms / DAY_MS);
}

/** Id of an open doc. One per post, viewer and UTC day, which is what makes opens dedupe for free. */
export function openDocId(postId: string, uid: string, ms: number): string {
  return `${postId}_${uid}_${utcDayNumber(ms)}`;
}

/** Calendar month key like "2026-10", used for monthly quotas. */
export function monthKey(ms: number): string {
  const d = new Date(ms);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}
